import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import './assets/vendors/style';
import MoodleRegistration from './containers/moodleRegistration';
import ResetPin from './containers/resetPin';
import Error404 from './components/Error404';
import { createTheme } from '@material-ui/core/styles';
import defaultTheme from './styles/themes/defaultTheme';
import { connect } from 'react-redux';
// import { MOODLE_REGISTRATION_PATH_NAME, MOODLE_RESET_PIN_PATH_NAME } from './constants/config';

class App extends Component {

  componentWillMount() {

    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    if (this.props.initURL === '') {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
  }

  render() {

    const { isDirectionRTL } = this.props;

    const applyTheme = createTheme(defaultTheme);

    if (isDirectionRTL) {
      applyTheme.direction = 'rtl';
      document.body.classList.add('rtl')
    } else {
      document.body.classList.remove('rtl');
      applyTheme.direction = 'ltr';
    }

    return (
      <div className="app-main">
        <Switch>
          <Route path='/' exact component={MoodleRegistration} />
          <Route path='/e_learning' exact component={MoodleRegistration} />
          <Route path='/company' exact component={MoodleRegistration} />
          <Route path='/e_learning/company' exact component={MoodleRegistration} />
          <Route path='/employee' exact component={MoodleRegistration} />
          <Route path='/e_learning/employee' exact component={MoodleRegistration} />
          <Route path='/details' exact component={MoodleRegistration} />
          <Route path='/e_learning/details' exact component={MoodleRegistration} />
          <Route path='/pin' exact component={MoodleRegistration} />
          <Route path='/e_learning/pin' exact component={MoodleRegistration} />
          <Route path='/security_questions' exact component={MoodleRegistration} />
          <Route path='/e_learning/security_questions' exact component={MoodleRegistration} />
          <Route path='/reset_pin' exact component={ResetPin} />
          <Route path='/e_learning/reset_pin' exact component={ResetPin} />
          <Route path='/reset_pin/answer' exact component={ResetPin} />
          <Route path='/e_learning/reset_pin/answer' exact component={ResetPin} />
          <Route path='/reset_pin/new_pin' exact component={ResetPin} />
          <Route path='/e_learning/reset_pin/new_pin' exact component={ResetPin} />
          <Route component={Error404} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = ({ ReducerMoodleRegistration }) => {
  const {
    isDirectionRTL
  } = ReducerMoodleRegistration;

  return {
    isDirectionRTL
  }
};

export default connect(mapStateToProps, {})(App);
